import { __assign } from "tslib";
import React from 'react';
import Animation from './Animation';
var Fade = function (props) { return (React.createElement(Animation, __assign({}, props, { transitionStyles: {
        entering: { opacity: 0, height: 0 },
        entered: { opacity: 1 },
        exiting: { opacity: 0, height: 0 },
        exited: { opacity: 0, height: 0 },
    } }), props.children)); };
var FadeUp = function (props) { return (React.createElement(Animation, __assign({}, props, { transitionStyles: {
        entering: { opacity: 0, transform: 'translateY(20px)', height: 0 },
        entered: { opacity: 1, transform: 'translateY(0px)' },
        exiting: { opacity: 0, transform: 'translateY(-20px)' },
        exited: { opacity: 0, transform: 'translateY(20px)' },
    } }), props.children)); };
var ScaleFade = function (props) { return (React.createElement(Animation, __assign({}, props, { transitionStyles: {
        entering: { opacity: 0, transform: 'scale(0.7)', height: 0 },
        entered: { opacity: 1, transform: 'scale(1)' },
        exiting: { opacity: 0, transform: 'scale(1)' },
        exited: { opacity: 0, transform: 'scale(1)' },
    } }), props.children)); };
export { Fade, FadeUp, ScaleFade };
export { Transition, TransitionGroup, CSSTransition, } from 'react-transition-group';
//# sourceMappingURL=index.js.map